import { ActionIcon, Box, Card, Group, Stack, Text, Tooltip } from '@mantine/core'
import { IconCopy } from '@/components/icons'
import type { CustomerRow, ProjectCustomerFieldRow } from '@/types/api'

type TicketCustomerFieldsCardProps = {
  customer: CustomerRow | null
  fields: ProjectCustomerFieldRow[]
  onCopy: (value: string) => void
}

export function TicketCustomerFieldsCard({
  customer,
  fields,
  onCopy,
}: TicketCustomerFieldsCardProps) {
  if (!customer || fields.length === 0) return null

  return (
    <Card withBorder padding="sm" radius="md">
      <Text fw={600} size="xs" mb={8}>
        Дополнительная информация
      </Text>
      <Stack gap={6}>
        {fields.map((field) => {
          const raw = customer.custom_fields?.[field.field_key]
          const val =
            raw === null || raw === undefined || raw === ''
              ? '—'
              : Array.isArray(raw)
                ? raw.join(', ')
                : String(raw)
          const copyText =
            raw === null || raw === undefined || raw === ''
              ? ''
              : Array.isArray(raw)
                ? raw.join(', ')
                : String(raw)
          return (
            <Box key={field.id}>
              <Text size="xs" c="dimmed" mb={2}>
                {field.name}
              </Text>
              <Group gap={6} wrap="nowrap" align="flex-start">
                <Text size="xs" style={{ whiteSpace: 'pre-wrap', flex: 1, minWidth: 0 }}>
                  {val}
                </Text>
                {copyText ? (
                  <Tooltip label="Копировать значение" withArrow>
                    <ActionIcon
                      size="xs"
                      variant="subtle"
                      aria-label={`Копировать поле «${field.name}»`}
                      style={{ flexShrink: 0, marginTop: 2 }}
                      onClick={() => onCopy(copyText)}
                    >
                      <IconCopy size={12} stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>
                ) : null}
              </Group>
            </Box>
          )
        })}
      </Stack>
    </Card>
  )
}
